"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _async = _interopRequireDefault(require("react-select/async"));
var _ClearIndicator = _interopRequireDefault(require("./shared/ClearIndicator"));
var _Control = _interopRequireDefault(require("./shared/Control"));
var _DropdownIndicator = _interopRequireDefault(require("./shared/DropdownIndicator"));
var _Group = _interopRequireDefault(require("./shared/Group"));
var _GroupHeading = _interopRequireDefault(require("./shared/GroupHeading"));
var _IndicatorsContainer = _interopRequireDefault(require("./shared/IndicatorsContainer"));
var _IndicatorSeparator = _interopRequireDefault(require("./shared/IndicatorSeparator"));
var _Input = _interopRequireDefault(require("./shared/Input"));
var _Menu = _interopRequireDefault(require("./shared/Menu"));
var _MultiValue = _interopRequireDefault(require("./shared/MultiValue"));
var _NoOptionMessage = _interopRequireDefault(require("./shared/NoOptionMessage"));
var _Option = _interopRequireDefault(require("./shared/Option"));
var _Placeholder = _interopRequireDefault(require("./shared/Placeholder"));
var _SingleValue = _interopRequireDefault(require("./shared/SingleValue"));
var _ValueContainer = _interopRequireDefault(require("./shared/ValueContainer"));
var _VirtualMenuList = _interopRequireDefault(require("./shared/VirtualMenuList"));
var _colors = require("../../theme/colors");
var _styles2 = require("./shared/styles");
var _sortUtils = require("../../utils/sort-utils");
var _classes = require("../../utils/classes");
var _excluded = ["classes", "customStyles", "dataMetrics", "error", "formatOptionLabel", "helperText", "isAsync", "isClearable", "isCreatable", "isDisabled", "isSearchable", "isMulti", "label", "maxLength", "menuPlacement", "onBlur", "options", "renderVirtual", "selectRef", "styles", "textFieldAdornment"],
  _excluded2 = ["error", "inputLabel"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var noOptionsMessage = function noOptionsMessage() {
  return 'No results found.';
};
var componentOverrides = function componentOverrides() {
  return {
    ClearIndicator: _ClearIndicator["default"],
    Control: _Control["default"],
    DropdownIndicator: _DropdownIndicator["default"],
    Group: _Group["default"],
    GroupHeading: _GroupHeading["default"],
    IndicatorsContainer: _IndicatorsContainer["default"],
    IndicatorSeparator: _IndicatorSeparator["default"],
    Input: _Input["default"],
    Menu: _Menu["default"],
    MultiValue: _MultiValue["default"],
    NoOptionsMessage: _NoOptionMessage["default"],
    Option: _Option["default"],
    Placeholder: _Placeholder["default"],
    SingleValue: _SingleValue["default"],
    ValueContainer: _ValueContainer["default"]
  };
};
var flattenNestedOptions = function flattenNestedOptions(options) {
  return options.flatMap(function (option) {
    if (option.options) {
      return option.options;
    }
    return option;
  });
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    decorations: {
      '&$inputLabel': {
        '&$error': {
          color: theme.palette.accent.redMain
        }
      }
    },
    error: {},
    inputLabel: {}
  };
});
var defaultProps = {
  alignment: 'left',
  customStyles: {},
  dataMetrics: {
    clearIndicator: 'fuse_select_clear_indicator',
    control: 'fuse_select_control',
    dropdownIndicator: 'fuse_select_dropdown_indicator',
    group: 'fuse_select_group',
    groupHeading: 'fuse_select_group_heading',
    indicatorsContainer: 'fuse_select_indicators_container',
    indicatorSeparator: 'fuse_select_indicator_separator',
    input: 'fuse_select_input',
    loadingMessage: 'fuse_select_loading_message',
    menu: 'fuse_select_menu',
    multiValue: 'fuse_select_multi_value',
    noOptionsMessage: 'fuse_select_no_options_message',
    option: 'fuse_select_option',
    placeholder: 'fuse_select_placeholder',
    root: 'fuse_select',
    singleValue: 'fuse_select_single_value',
    valueContainer: 'fuse_select_value_container'
  },
  InputProps: {
    inputProps: {}
  },
  isAsync: false,
  isClearable: false,
  isCreatable: false,
  isDisabled: false,
  isMulti: false,
  isSearchable: true,
  menuPlacement: 'auto',
  onBlur: function onBlur() {},
  variant: 'withMenu'
};

/**
 * Select is a type of input that is used in forms, where a user is submitting data and chooses one option from a list.
 * Use a single-select to give people the ability to search and make one or more choices from multiple options.
 */
var Select = function Select(_ref) {
  var _ref$classes = _ref.classes,
    propClasses = _ref$classes === void 0 ? {} : _ref$classes,
    customStyles = _ref.customStyles,
    dataMetrics = _ref.dataMetrics,
    error = _ref.error,
    formatOptionLabel = _ref.formatOptionLabel,
    helperText = _ref.helperText,
    isAsync = _ref.isAsync,
    isClearable = _ref.isClearable,
    isCreatable = _ref.isCreatable,
    isDisabled = _ref.isDisabled,
    isSearchable = _ref.isSearchable,
    isMulti = _ref.isMulti,
    label = _ref.label,
    maxLength = _ref.maxLength,
    menuPlacement = _ref.menuPlacement,
    onBlur = _ref.onBlur,
    options = _ref.options,
    renderVirtual = _ref.renderVirtual,
    selectRef = _ref.selectRef,
    styles = _ref.styles,
    textFieldAdornment = _ref.textFieldAdornment,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    dynamicOptions = _useState2[0],
    setDynamicOptions = _useState2[1];
  var selectClasses = (0, _classes.mergeClasses)(useStyles(), propClasses);
  var selectStyles = (0, _styles2.useSelectStyles)({
    isClearable: isClearable,
    isDisabled: isDisabled,
    isMulti: isMulti
  });
  var _selectStyles$selectC = _objectSpread({}, selectStyles, {}, selectClasses),
    errorClass = _selectStyles$selectC.error,
    inputLabelClass = _selectStyles$selectC.inputLabel,
    mergedClasses = (0, _objectWithoutProperties2["default"])(_selectStyles$selectC, _excluded2);
  var getLibraryComponent = function getLibraryComponent() {
    if (isCreatable && !isAsync) {
      return _creatable["default"];
    }
    if (isAsync && !isCreatable) {
      return _async["default"];
    }
    return _reactSelect["default"];
  };
  var handleInputChange = function handleInputChange(inputValue, _ref2) {
    var action = _ref2.action;
    if (action === 'input-change' || action === 'menu-close') {
      if (!inputValue) {
        return setDynamicOptions(null);
      }
      var flattened = flattenNestedOptions(options || []);
      var filtered = flattened.filter(function (_ref3) {
        var optLabel = _ref3.label,
          _ref3$isOptionSearcha = _ref3.isOptionSearchable,
          isOptionSearchable = _ref3$isOptionSearcha === void 0 ? true : _ref3$isOptionSearcha;
        return isOptionSearchable && optLabel.toString().toLowerCase().includes(inputValue.toLowerCase());
      });
      filtered.sort(function (a, b) {
        return (0, _sortUtils.sortOptionsForSearch)(a, b, inputValue);
      });
      setDynamicOptions(filtered);
    }
    if (action === 'set-value') {
      setDynamicOptions(null);
    }
  };
  var handleOnBlur = function handleOnBlur() {
    onBlur();
    setDynamicOptions(null);
  };
  var SelectComponent = getLibraryComponent();
  var overrides = componentOverrides({
    dataMetrics: dataMetrics
  });
  if (renderVirtual === true) {
    overrides.MenuList = _VirtualMenuList["default"];
  }
  var internalRef = (0, _react.useRef)(null);
  var ref = selectRef || internalRef;
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(SelectComponent, (0, _extends2["default"])({
    classes: mergedClasses,
    components: overrides,
    dataMetrics: dataMetrics,
    formatOptionLabel: formatOptionLabel,
    hideSelectedOptions: false,
    isClearable: isClearable,
    isDisabled: isDisabled,
    isMulti: isMulti,
    isMultiWithChips: isMulti,
    isSearchable: isSearchable,
    maxLength: maxLength,
    menuPlacement: menuPlacement,
    menuPosition: "absolute",
    noOptionsMessage: noOptionsMessage,
    onInputChange: handleInputChange,
    onBlur: handleOnBlur,
    options: dynamicOptions || options,
    ref: ref,
    selectRef: ref,
    styles: _objectSpread({}, _styles2.customSelectStyles, {}, customStyles, {}, styles),
    textFieldProps: {
      dataMetrics: {
        root: mergedDataMetrics.root
      },
      disabled: isDisabled,
      error: error,
      helperText: helperText,
      InputLabelProps: {
        classes: {
          error: (0, _classnames["default"])(errorClass, selectClasses.decorations, selectClasses.inputLabel, selectClasses.error),
          root: inputLabelClass
        },
        disabled: isDisabled,
        error: error,
        shrink: true
      },
      label: label
    },
    textFieldAdornment: textFieldAdornment,
    theme: function theme(_theme) {
      return _objectSpread({}, _theme, {
        colors: _objectSpread({}, _theme.colors, {
          primary: _colors.opacity.primary[500][14],
          primary25: _colors.opacity.black[8],
          primary50: _colors.opacity.primary[500][14],
          primary75: _colors.opacity.primary[500][14]
        })
      });
    }
  }, rest));
};
Select.defaultProps = defaultProps;
Select.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Specify alignment for the drop menu if the menu is wider or shorter than the select control.
   */
  alignment: _propTypes["default"].oneOf(['left', 'right', 'center']),
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/select/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * If `true`, the select will close when an item is selected.
   */
  className: _propTypes["default"].string,
  /**
   * className to pass into component.
   */
  closeMenuOnSelect: _propTypes["default"].bool,
  /**
   * Custom styles
   */
  customStyles: _propTypes["default"].object,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    clearIndicator: _propTypes["default"].string,
    control: _propTypes["default"].string,
    dropdownIndicator: _propTypes["default"].string,
    group: _propTypes["default"].string,
    groupHeading: _propTypes["default"].string,
    indicatorsContainer: _propTypes["default"].string,
    indicatorSeparator: _propTypes["default"].string,
    input: _propTypes["default"].string,
    loadingMessage: _propTypes["default"].string,
    menu: _propTypes["default"].string,
    multiValue: _propTypes["default"].string,
    noOptionsMessage: _propTypes["default"].string,
    option: _propTypes["default"].string,
    placeholder: _propTypes["default"].string,
    root: _propTypes["default"].string,
    singleValue: _propTypes["default"].string,
    valueContainer: _propTypes["default"].string
  }),
  /**
   * If `true`, the select will be in an error state.
   */
  error: _propTypes["default"].bool,
  /**
   * Custom styles for option label
   */
  formatOptionLabel: _propTypes["default"].func,
  /**
   * The helperText for the textField
   */
  helperText: _propTypes["default"].string,
  /**
   * The id of the `input` element.
   */
  id: _propTypes["default"].string,
  /**
   * Additional props to apply to the inner Input Components.
   *
   * This component contains two levels of div tags ".MuiInputBase-root" &
   * ".MuiInputBase-input" which can both have additional props.
   *
   * The ".MuiInputBase-root" (props for the top level div) needs to be placed
   * directly on the InputProps object.
   *
   * The ".MuiInputBase-input" (props for the nested div) needs to be placed
   * inside of the "inputProps" key of the InputProps object as shown in the
   * example.
   *
   * Common use case for needing both props is the need to over-ride the
   * min-width of 280px.  The style will need to be applied to both the top and
   * the nested div so they will both respect the width of the outer container.
   *
   * ```
   * {
   *   InputProps: {
   *     automationId: 'myInputId',
   *     style: { maxWidth: 0 },
   *     inputProps: {
   *       automationId: 'myInnerInputId',
   *       style: { maxWidth: 0 }
   *     }
   *   }
   * }
   * ```
   */
  InputProps: _propTypes["default"].object,
  /**
   * If `true`, the select will have async loading.
   */
  isAsync: function isAsync(_ref4, propName, componentName) {
    var isCreatable = _ref4.isCreatable,
      _isAsync = _ref4.isAsync;
    if (typeof _isAsync !== 'boolean') {
      // eslint-disable-next-line max-len
      return new Error("Invalid prop '".concat(propName, "' of type '").concat((0, _typeof2["default"])(_isAsync), "' supplied to '").concat(componentName, "', expected 'boolean'."));
    }
    if (isCreatable && _isAsync) {
      return new Error('Cannot set both isAsync and isCreatable');
    }
    return null;
  },
  /**
   * If `true`, the ClearIndicator will appear after a value is selected. The
   * ClearIndicator, when clicked, will clear the selected value
   */
  isClearable: _propTypes["default"].bool,
  /**
   * If `true`, the component will allow the typed value to be created as a new
   * option.
   */
  isCreatable: function isCreatable(_ref5, propName, componentName) {
    var _isCreatable = _ref5.isCreatable,
      isAsync = _ref5.isAsync;
    if (typeof _isCreatable !== 'boolean') {
      return new Error( // eslint-disable-next-line max-len
      "Invalid prop '".concat(propName, "' of type '").concat((0, _typeof2["default"])(_isCreatable), "' supplied to '").concat(componentName, "', expected 'boolean'."));
    }
    if (_isCreatable && isAsync) {
      return new Error('Cannot set both isAsync and isCreatabled');
    }
    return null;
  },
  /**
   * If `true`, the select will be disabled.
   */
  isDisabled: _propTypes["default"].bool,
  /**
   * If `true`, the select will be a multi-select with chips
   */
  isMulti: _propTypes["default"].bool,
  /**
   * If `true`, the search function is enabled.
   */
  isSearchable: _propTypes["default"].bool,
  /*
   * The label for the textField
   */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * If provided, options created in concert with `isCreatable=true` cannot be
   * longer than this value
   */
  maxLength: _propTypes["default"].number,
  /**
   * Set whether the menu should be at the `top`, `bottom`, or `auto` based on position in the DOM
   */
  menuPlacement: _propTypes["default"].oneOf(['top', 'bottom', 'auto']),
  /**
   * CSS for width, such as 'fit-content', '100px', etc. Will be applied to the drop menu. Optional.
   */
  menuWidth: _propTypes["default"].string,
  /**
   * Callback fire when input is blurred.
   */
  onBlur: _propTypes["default"].func,
  /**
   * Callback fired when the state is changed.
   */
  onChange: _propTypes["default"].func,
  /**
   * options to be displayed for the options of the select.
   * ```label``` and ```value``` are **required**.
   */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    isOptionSearchable: _propTypes["default"].bool,
    label: _propTypes["default"].oneOfType([_propTypes["default"].string.isRequired, _propTypes["default"].number.isRequired]),
    value: _propTypes["default"].oneOfType([_propTypes["default"].string.isRequired, _propTypes["default"].number.isRequired])
  })),
  /**
   * the ghost text displayed before a value is selected
   */
  placeholder: _propTypes["default"].node,
  /**
   * If `true`, the component will render list options virtually.
   * Useful for large datasets. See
   * [react-window](https://www.npmjs.com/package/react-window).
   */
  renderVirtual: _propTypes["default"].bool,
  /**
   * Ref attached to the React-Select instance
   */
  selectRef: _propTypes["default"].object,
  /**
   * @ignore
   */
  styles: _propTypes["default"].object,
  /**
   * If `true` and isSearchable is `true`, search icon adornment will be used
   * in the text field
   */
  textFieldAdornment: _propTypes["default"].bool,
  theme: _propTypes["default"].object,
  /**
   * The value of the component that will be highlighted in the dropdown list.
   * ```value: {label: 'item1', value: 'item1'}```
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  /**
   * Specifies how options drop list should be rendered.
   * Variant "withMenu" will use Popper component to render the drop list.
   * Variant "standalone" will use Paper component to render the drop list.
   * IMPORTANT: Paper-based drop list may be clipped if the container has style {"overflow": "hidden"}
   */
  variant: _propTypes["default"].oneOf(['standalone', 'withMenu'])
} : {};
var _default = Select;
exports["default"] = _default;